export const nexterfieldChange = ( defaultVal = undefined , value  = '', res = false , device = 'md' , field = false , unitcheck = false , urlCheck = false , selectRes = false ) => {
	if( defaultVal != undefined){
		if( res ){
			if(field){
				if( value[device] && defaultVal[device] ){
					if( value[device]['top'] !== defaultVal[device]['top'] || value[device]['right'] !== defaultVal[device]['right'] || value[device]['bottom'] !== defaultVal[device]['bottom'] || value[device]['left'] !== defaultVal[device]['left'] ){
						return ' nexter-field-changed'
					}
				}
			}else if( unitcheck ){
				if ( value['unit'] !== undefined && defaultVal['unit'] !== undefined) {
					if( ( value['unit'] !== defaultVal['unit'] ) || ( value[device] !== defaultVal[device] ) ){
						return ' nexter-field-changed'
					}
				}

				if( value[device] !== undefined  && defaultVal[device] !== undefined ){
					if( value[device] !== defaultVal[device] ){
						return ' nexter-field-changed'
					}	
				}

			}else if( selectRes ){
				if( value[device] !== defaultVal[device] ){
					return ' nexter-field-changed'
				}
			}else if( value[device] && defaultVal[device] && ( value[device] !== defaultVal[device] ) ){
				return ' nexter-field-changed'
			}
		}else if(urlCheck){	
			if ( ( defaultVal.url !== '' || typeof value.url !== 'undefined' ) && ( defaultVal.url !== value.url ) ) {
				return ' nexter-field-changed'
			}
		}else if(defaultVal != value){
			return ' nexter-field-changed'
		}
	}

	return ''
}